<template>
  <v-toolbar
    v-if="option"
    elevation="0"
    height="58"
    class="px-1 pt-1"
  >
    <v-btn
      icon
      color="textBlack"
      @click="$emit('backClick')"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <v-toolbar-title class="header-title textBlack--text pl-2">
      {{ option.name }}
    </v-toolbar-title>

    <v-spacer />

    <v-btn
      v-if="canGoHome"
      icon
      color="textBlack"
      @click="$emit('homeClick')"
    >
      <v-icon>mdi-home</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
  export default {
    name: 'OptionsHeader',

    props: {
      option: Object,
      canGoHome: Boolean,
    },
  }
</script>

<style scoped>
.header-title {
  font-size: 1.05rem;
}
</style>
